import React, { useEffect, useState } from 'react';
import '../assets/vendors/mdi/css/materialdesignicons.min.css';
import '../assets/vendors/css/vendor.bundle.base.css';
import '../assets/css/style.css';

import logo from '../assets/images/logo.svg';
import logomini from '../assets/images/logo-mini.svg';
import face0 from '../assets/images/faces/face0.jpg';
import face15 from '../assets/images/faces/face15.jpg';
import face2 from '../assets/images/faces/face2.jpg';
import face3 from '../assets/images/faces/face3.jpg';
import face4 from '../assets/images/faces/face4.jpg';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'; // Import Outlet to render nested routes
import UserService from '../services/userService';
import { useTranslation } from 'react-i18next';
import SettingsModal from '../modals/SettingsModal';
import { UserSetting } from '../types/UserSetting';
import SettingService from '../services/settingService';
import AdvancedSettingsModal from '../modals/AdvancedSettingsModal';
import { AdvancedSetting } from '../types/AdvancedSetting';
import AdvancedService from '../services/advancedService';
import { ToastType, useToast } from './toast/ToastProvider';

const Main = () => {
  const { t, i18n } = useTranslation();
  const { showToast } = useToast();
  const currentLocation = useLocation(); 
  const navigate = useNavigate();
  const [name, setName] = useState<any | null>(null);
  const [email, setEmail] = useState<string | null>(null);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [showAdvancedSettingsModal, setShowAdvancedSettingsModal] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const isRtl = i18n.language === 'he';

  useEffect(() => {
    const storedName = sessionStorage.getItem("name");
    const storedEmail = sessionStorage.getItem("email");
    if (storedName) {
      setName(storedName); // Set user state from sessionStorage
    }
    if (storedEmail) {
      setEmail(storedEmail); 
    }
  }, []);


  const handleLogout = async () => {
    const response = await UserService.logout(navigate);
  };

  const handleLogoClick = () => {
    navigate('/calendar');
  };

  const handleOpenSettingModal = () => {
    setShowSettingsModal(true);
  };

  const handleOpenAdvancedSettingModal = () => {
    setShowAdvancedSettingsModal(true);
  };

  const handleSaveSettings = async (settingObj: UserSetting) => {
    try {
      const saveResult = await SettingService.save(settingObj);
      if (saveResult.success) {
        showToast(t(`toastMessages.USER_SETTINGS_SAVED`), ToastType.Success);
        setShowSettingsModal(false);
      }
      else {
        showToast(saveResult.message || 'Failed to save advanced settings', ToastType.Warning);
      }
    } catch (err) {
      showToast(t(`toastMessages.ADVANCED_SETTINGS_SAVE_FAILED`), ToastType.Warning);
    }
  };

  const handleSaveAdvancedSettings = async (advancedSetting: AdvancedSetting) => {
    try {
      const saveResult = await AdvancedService.save(advancedSetting);
      if (saveResult.success) {
        showToast(t(`toastMessages.ADVANCED_SETTINGS_SAVED`), ToastType.Success);
        setShowAdvancedSettingsModal(false);
      }
      else {
        showToast(saveResult.message || 'Failed to save advanced settings', ToastType.Warning);
      }
    } catch (err) {
      showToast(t(`toastMessages.ADVANCED_SETTINGS_SAVE_FAILED`), ToastType.Warning);
    }
  };

  return (
    <div className="container-scroller">
    
    <nav className={`sidebar sidebar-offcanvas ${isSidebarOpen ? 'active' : ''}`} id="sidebar">
      <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
          {/* <a className="sidebar-brand brand-logo" onClick={handleLogoClick}>
            <img src={logo} alt="logo" />
            <span className="card-title">softneto CRM</span>
          </a> */}
          <a className="sidebar-brand brand-logo" onClick={handleLogoClick}>
            <img src={logo} alt="logo" style={{ width: 35, height: 35 }}/>
            <span className={`fs-5 text-white ${isRtl ? 'me-2' : 'ms-2'}`}>softneto CRM</span>
          </a>


        <a className="sidebar-brand brand-logo-mini" onClick={handleLogoClick}>
          <img src={logomini} alt="logo" />
        </a>
      </div>
      <ul className="nav">
        <li className="nav-item profile">
          <div className="profile-desc">
            <div className="profile-pic">
              <div className="count-indicator">
                <img className="img-xs rounded-circle " src={face0} alt=""/>
                <span className="count bg-success"></span>
              </div>
              <div className="profile-name">
                <h5 className="mb-0 font-weight-normal">{name}</h5>
                <span>Gold Member</span>
              </div>
            </div>
            <a style={{ pointerEvents: 'none', opacity: 0.6 }} id="profile-dropdown" data-bs-toggle="dropdown"><i className="mdi mdi-dots-vertical"></i></a>
            <div className="dropdown-menu dropdown-menu-right sidebar-dropdown preview-list" aria-labelledby="profile-dropdown">
              <a href="#" className="dropdown-item preview-item">
                <div className="preview-thumbnail">
                  <div className="preview-icon bg-dark rounded-circle">
                    <i className="mdi mdi-settings text-primary"></i>
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject ellipsis mb-1 text-small">Account settings</p>
                </div>
              </a>
              <div className="dropdown-divider"></div>
              <a href="#" className="dropdown-item preview-item">
                <div className="preview-thumbnail">
                  <div className="preview-icon bg-dark rounded-circle">
                    <i className="mdi mdi-onepassword  text-info"></i>
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject ellipsis mb-1 text-small">Change Password</p>
                </div>
              </a>
              <div className="dropdown-divider"></div>
              <a href="#" className="dropdown-item preview-item">
                <div className="preview-thumbnail">
                  <div className="preview-icon bg-dark rounded-circle">
                    <i className="mdi mdi-calendar-today text-success"></i>
                  </div>
                </div>
                <div className="preview-item-content">
                  <p className="preview-subject ellipsis mb-1 text-small">To-do list</p>
                </div>
              </a>
            </div>
          </div>
        </li>
        <li className="nav-item nav-category">
          <span className="nav-link">{t('navigation')}</span>
        </li>
        <li className={`nav-item menu-items ${currentLocation.pathname === '/calendar' ? 'active' : ''}`}>
            <NavLink to="/calendar" className='nav-link' onClick={() => setIsSidebarOpen(false)}>
              <span className="menu-icon">
                <i className="mdi mdi-calendar-today"></i>
              </span>
              <span className="menu-title">{t('calendar')}</span>
            </NavLink>
        </li>
        <li className={`nav-item menu-items ${currentLocation.pathname === '/booking' ? 'active' : ''}`}>
            <NavLink to="/booking" className='nav-link' onClick={() => setIsSidebarOpen(false)}>
              <span className="menu-icon">
                <i className="mdi mdi-playlist-check"></i>
              </span>
              <span className="menu-title">{t('booking-view')}</span>
            </NavLink>
        </li>
        <li className={`nav-item menu-items ${currentLocation.pathname === '/preferences' ? 'active' : ''}`}>
            <NavLink to="/preferences" className='nav-link' onClick={() => setIsSidebarOpen(false)}>
              <span className="menu-icon">
                <i className="mdi mdi-tune"></i>
              </span>
              <span className="menu-title">{t('booking-preferences')}</span>
            </NavLink>
        </li>
        {/* <li className="nav-item menu-items"> */}
        <li className={`nav-item menu-items ${currentLocation.pathname === '/patients' ? 'active' : ''}`}>
          <NavLink to="/patients" className='nav-link' onClick={() => setIsSidebarOpen(false)}>
              <span className="menu-icon">
                <i className="mdi mdi-contacts"></i>
              </span>
              <span className="menu-title">{t('patients')}</span>
          </NavLink>
        </li>
        <li className={`nav-item menu-items ${currentLocation.pathname === '/leads' ? 'active' : ''}`}>
            <NavLink to="/leads" className='nav-link' onClick={() => setIsSidebarOpen(false)}>
              <span className="menu-icon">
                <i className="mdi mdi-file-document-box"></i>
              </span>
              <span className="menu-title">{t('leads')}</span>
            </NavLink>
        </li>
      </ul>
    </nav>
    
    <div className="container-fluid page-body-wrapper">
      
      <nav className="navbar p-0 fixed-top d-flex flex-row">
        <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
            <a className="navbar-brand brand-logo-mini" onClick={handleLogoClick}>
              <img src={logomini} alt="logo" />
            </a>
        </div>
        <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
          <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
            <span className="mdi mdi-menu"></span>
          </button>
          <ul className="navbar-nav w-100">
            <li className="nav-item w-100">
              <form className="nav-link mt-2 mt-md-0 d-none d-lg-flex search">
                <input type="text" className="form-control" placeholder="Search"/>
              </form>
            </li>
          </ul>
          <ul className="navbar-nav navbar-nav-right">
            <li className="nav-item dropdown d-none d-lg-block">
              <a style={{ pointerEvents: 'none', opacity: 0.6 }} className="nav-link btn btn-success create-new-button" id="createbuttonDropdown" data-bs-toggle="dropdown" aria-expanded="false" href="#">+ Create New Project</a>
              <div className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="createbuttonDropdown">
                <h6 className="p-3 mb-0">Projects</h6>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item preview-item">
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-file-outline text-primary"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject ellipsis mb-1">Software Development</p>
                  </div>
                </a>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item preview-item">
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-web text-info"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject ellipsis mb-1">UI Development</p>
                  </div>
                </a>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item preview-item">
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-layers text-danger"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject ellipsis mb-1">Software Testing</p>
                  </div>
                </a>
                <div className="dropdown-divider"></div>
                <p className="p-3 mb-0 text-center">See all projects</p>
              </div>
            </li>
            <li className="nav-item nav-settings d-none d-lg-block">
              <a className="nav-link" href="#">
                <i className="mdi mdi-view-grid"></i>
              </a>
            </li>
            <li className="nav-item dropdown border-left">
              <a style={{ pointerEvents: 'none', opacity: 0.6 }} className="nav-link count-indicator dropdown-toggle" id="messageDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                <i className="mdi mdi-email"></i>
                <span className="count bg-success"></span>
              </a>
              <div className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="messageDropdown">
                <h6 className="p-3 mb-0">Messages</h6>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item preview-item">
                  <div className="preview-thumbnail">
                    <img src={face4} alt="image" className="rounded-circle profile-pic"/>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject ellipsis mb-1">Mark send you a message</p>
                    <p className="text-muted mb-0"> 1 Minutes ago </p>
                  </div>
                </a>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item preview-item">
                  <div className="preview-thumbnail">
                    <img src={face2} alt="image" className="rounded-circle profile-pic"/>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject ellipsis mb-1">Cregh send you a message</p>
                    <p className="text-muted mb-0"> 15 Minutes ago </p>
                  </div>
                </a>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item preview-item">
                  <div className="preview-thumbnail">
                    <img src={face3} alt="image" className="rounded-circle profile-pic"/>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject ellipsis mb-1">Profile picture updated</p>
                    <p className="text-muted mb-0"> 18 Minutes ago </p>
                  </div>
                </a>
                <div className="dropdown-divider"></div>
                <p className="p-3 mb-0 text-center">4 new messages</p>
              </div>
            </li>
            <li className="nav-item dropdown border-left">
              <a style={{ pointerEvents: 'none', opacity: 0.6 }} className="nav-link count-indicator dropdown-toggle" id="notificationDropdown" href="#" data-bs-toggle="dropdown">
                <i className="mdi mdi-bell"></i>
                <span className="count bg-danger"></span>
              </a>
              <div className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="notificationDropdown">
                <h6 className="p-3 mb-0">Notifications</h6>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item preview-item">
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-calendar text-success"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-1">Event today</p>
                    <p className="text-muted ellipsis mb-0"> Just a reminder that you have an event today </p>
                  </div>
                </a>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item preview-item">
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-settings text-danger"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-1">Settings 111</p>
                    <p className="text-muted ellipsis mb-0"> Update dashboard </p>
                  </div>
                </a>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item preview-item">
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-link-variant text-warning"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-1">Launch Admin</p>
                    <p className="text-muted ellipsis mb-0"> New admin wow! </p>
                  </div>
                </a>
                <div className="dropdown-divider"></div>
                <p className="p-3 mb-0 text-center">See all notifications</p>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link" id="profileDropdown" href="#" data-bs-toggle="dropdown">
                <div className="navbar-profile">
                  <img className="img-xs rounded-circle" src={face0} alt=""/>
                  <p className="mb-0 d-none d-sm-block navbar-profile-name">{name}</p>
                  <i className="mdi mdi-menu-down d-none d-sm-block"></i>
                </div>
              </a>
              <div className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="profileDropdown">
                <h6 className="p-3 mb-0">{email}</h6>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item preview-item" onClick={handleOpenSettingModal}>
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-settings text-success"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-1">{t('settings')}</p>
                  </div>
                </a>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item preview-item" onClick={handleLogout}>
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-logout text-danger"></i>
                    </div>
                  </div>
                  <div className="preview-item-content" style={{ cursor: "pointer" }}>
                    <p className="preview-subject mb-1">{t('log-out')}</p>
                  </div>
                </a>
                <div className="dropdown-divider"></div>
                <p className="p-3 mb-0 text-center" onClick={handleOpenAdvancedSettingModal}>{t('advanced-settings')}</p>
              </div>
            </li>
          </ul>
          <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            <span className="mdi mdi-format-line-spacing"></span>
          </button>
        </div>
      </nav>
      
      <div className="main-panel">
        <div className="content-wrapper">
          <Outlet /> {/* This will render the content of the matched route */}
        </div>
        
        
        <footer className="footer">
          <div className="d-sm-flex justify-content-center justify-content-sm-between">
            <span className="text-muted d-block text-center text-sm-left d-sm-inline-block">Copyright © softneto.com 2025</span>
            <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center"> Free <a href="https://www.bootstrapdash.com/bootstrap-admin-template/" target="_blank">Bootstrap admin template</a> from Bootstrapdash.com</span>
          </div>
        </footer>
        
      </div>
      
    </div>
    
      <SettingsModal
        show={showSettingsModal}
        onClose={() => setShowSettingsModal(false)}
        onSave={handleSaveSettings}
      />

      <AdvancedSettingsModal
        show={showAdvancedSettingsModal}
        onClose={() => setShowAdvancedSettingsModal(false)}
        onSave={handleSaveAdvancedSettings}
      />

  </div>

  );
};

export default Main;


    {/* <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"> */}